import ProfilePersonalService from "@services/profile-personal-service";
import { getSingleInstanceByElement, getSingleInstanceByName } from "../../../core";
import Component from "../../component.abstract";
import { notifyFromAlert } from "../../helpers/notifs";
import SuggestInput from "../../inputs/autocomplete/autocomplete";
import AdvancedPassword from "../../inputs/password/advanced-password";
import SimpleProgress from "../../simple-progress/simple-progress";
import ProfileInformations from "../informations/profile-informations";
import { PersonalDataFields } from "./personal-data-fields";

interface ProfilePersonalProps {
    url: string;
}

export default class ProfilePersonal extends Component {
    private saveButton: HTMLElement;
    private profileInformations:ProfileInformations;
    private nameInput: HTMLInputElement;
    private firstNameInput: HTMLInputElement;
    private emailInput: HTMLInputElement;
    private passwordInput: AdvancedPassword;
    private phoneInput: HTMLInputElement;
    private cityInput: SuggestInput;
    private countryInput: SuggestInput;
    private countriesFromEu: Array<string>;
    private url:string;
    private cityInputParent: Element;
    private workPermitInputParent: Element;
    private data: any;
    private previousData: PersonalDataFields;
    private _isInFrance: boolean;
    private _isInEU: boolean;

    constructor(private props: ProfilePersonalProps, element: HTMLElement) {
         super(props, element);
         this.props.url ? this.url = this.props.url : undefined;
    }
    mounted(): void {
        this.injectTemplate();
        this.profileInformations = getSingleInstanceByName("ProfileInformations");
       
        this.saveButton = this.element.querySelector(".profile-form-save");

        this.nameInput = this.element.querySelector("input#name");
        this.firstNameInput = this.element.querySelector("input#firstname");
        this.emailInput = this.element.querySelector("input#email");
        this.phoneInput = this.element.querySelector("input#phone");

        this.passwordInput = getSingleInstanceByElement("AdvancedPassword", this.element.querySelector("[data-advanced-password]"))
        this.cityInputParent = this.element.querySelector("input[name=city]").parentElement;
        this.workPermitInputParent = this.element.querySelector("input[name=radio-license]").parentElement;

        this.cityInput = getSingleInstanceByElement("SuggestInput", this.element.querySelector("input[data-autocomplete][name=city]"));

        this.countryInput = getSingleInstanceByElement("SuggestInput", this.element.querySelector("input[data-autocomplete][name=country]"))
        PubSub.subscribe("suggest-change", (msg:string, instance:SuggestInput) => {
            if(instance.getElement() === this.countryInput.getElement()) {
                const country = instance.getValue().country;
                    
                    if(country === "") return;

                    this._isInEU = true;
                    this._isInFrance = false;
                    if(country === "France") {
                        this._isInFrance = true;
                        this.cityInputParent.classList.remove("hidden"); 
                        this.workPermitInputParent.classList.add("hidden");
                        this.unsetWorkPermit();
                    } else {
                        this.cityInputParent.classList.add("hidden");
                        this.cityInput.unselectAll();

                        if(this.countriesFromEu.indexOf(country) > -1) {
                            // if selected country IS in EU : display city field
                            this.workPermitInputParent.classList.add("hidden");
                            this.unsetWorkPermit();
                        } else {
                            // if selected country ISN'T in EU display work permit field
                            this._isInEU = false;
                            this.workPermitInputParent.classList.remove("hidden");  
                        }
                    }
            }
        });

        this.saveButton.addEventListener("click", () => {
            this.save()
        })
        if (this.url) {
            this.call();
        }

    }
    setUrl(newurl:string):void {
        this.url = newurl;
    }
    getUrl():string {
        return this.url;
    }
    unsetWorkPermit():void {
        const radios = this.element.querySelectorAll<HTMLInputElement>("input[name=radio-license]");       
        for (let i = 0; i < radios.length; i++) {
            radios[i].checked = false;
        }
    }
    save():void {
        const data = this.getFields();
        data.currentLocality = {isInEU : this._isInEU, isInFrance : this._isInFrance};
        // Get password after as it can be filled by the autofill
        const passwords = this.passwordInput.getValues();
        if (passwords.new) {
            data.password = passwords.new;
        }
        if (passwords.password) {
            data.oldPassword = passwords.password;
        }

        const isValid = data.checkValidity();
        if (!isValid) {
            return this.displayError(data.getError());
        }

        this.saveButton.classList.add("disabled");
        const progressButtonInstance: SimpleProgress = getSingleInstanceByElement("SimpleProgress", this.saveButton)
        progressButtonInstance.start();
        const service = new ProfilePersonalService(this.url);

        service.setErrorHandler((error:any) => {
            let message: string;
            if(error?.Message) {
                message = error.Message;
            }
            this.displayError(message)
            this.saveButton.classList.remove("disabled");
            progressButtonInstance.stop();
        });

        service.post(data.toJson(), (response: any) => {
            if (response.infosProfil) {
                this.previousData = data;
                this.passwordInput.setValue("");
                this.passwordInput.collapse();
                this.passwordInput.simplePasswordReset();
                this.profileInformations.setData(response.infosProfil);
                this.profileInformations.displayResults();
                this.profileInformations.initSearchLabels();
                this.profileInformations.setCompletion();
            }

             notifyFromAlert({
                    "Icon": 0,
                    "Message": response.message,
                    "AnalyticsTrackings": "",
                    "sticky": true,
                    "vanish": true
            }, true);
            //Add tracking event on save profil information
            if(this.data.trackingsClick && this.data.trackingsClick.length) {
                window.dataLayer.push(this.data.trackingsClick[0])
            }
            this.saveButton.classList.remove("disabled");
            progressButtonInstance.stop();

            if (response.redirectUrl) {
                // Wait until the user can read the redirection notification.
                setTimeout(() => {
                    window.location.replace(response.redirectUrl)    
                }, 5000)
            }
        });
    }
    call():void {
        const service = new ProfilePersonalService(this.url);

        service.setErrorHandler((error:any) => {
            let message: string;
            if(error?.Message) {
                message = error.Message;
            }
            this.displayError(message)
        });

        service.get((response:any) => {
             try {
                    this.data = response;
                    this.setFields();
                } catch(e) {
                    this.displayError();
                }
                //Add tracking event on load
                if (this.data.trackingsLoad && this.data.trackingsLoad.length) {
                    this.data.trackingsLoad[0].event = "VirtualPageview"
                    window.dataLayer.push(this.data.trackingsLoad[0])
                }
        });
    }
    displayError(message?: string):void {
        notifyFromAlert({
            "Icon": 2,
            "Message": message ? message : "Aïe, une erreur est survenue, rechargez la page et réessayez.",
            "AnalyticsTrackings": "",
            "sticky": true
        }, true);
    }
    setFields():void {
        this.countriesFromEu = this.data.countriesFromEu ? this.data.countriesFromEu : [] ;
        
        if (this.data.country) {
            this.countryInput.selectAuto({
                "id": this.data.country.uri,
                "value": this.data.country.label
            });
        }
        
        if (this.data.city) {
            this.cityInput.selectAuto({
                "id": this.data.city.uri,
                "value": this.data.city.label
            });
        }
        
        this.nameInput.value = this.data.name ? this.data.name : "";
        this.firstNameInput.value = this.data.firstName ? this.data.firstName : "";
        this.emailInput.value = this.data.email ? this.data.email : "";
        this.phoneInput.value = this.data.phone ? this.data.phone : "";
        this.passwordInput.setValue("");
        
        // User hasn't yet created a password display a simple password input
        if(!this.data.hasPassword) this.passwordInput.simplePassword();

        if (typeof this.data.isWorkPermit === "boolean") {
            if (this.data.isWorkPermit) {
                this.element.querySelector<HTMLInputElement>("input[name=radio-license][value=yes]").checked = true
            } else {
                this.element.querySelector<HTMLInputElement>("input[name=radio-license][value=no]").checked = true
            }
        } else {
            this.unsetWorkPermit();
        }

        this.previousData = this.getFields();
        this.element.classList.remove('pending');
    }
    getFields(): PersonalDataFields {
        const radio = document.querySelector<HTMLInputElement>("input[name=radio-license]:checked");

        const dataFields = new PersonalDataFields ()
        dataFields.name = this.nameInput.value
        dataFields.firstName = this.firstNameInput.value
        dataFields.email = this.emailInput.value
        dataFields.phone = this.phoneInput.value
        dataFields.country = {
            "label": this.countryInput.getValue().country,
            "uri": this.countryInput.getValue().country_autocomplete,
            isValid() {
                return !!this.uri;
            }
        };
        dataFields.city = {
            "label": this.cityInput.getValue().city,
            "uri": this.cityInput.getValue().city_autocomplete,
            isValid() {
                return !!this.uri;
            }
        };
        dataFields.isWorkPermit = radio?.value;
        return dataFields;
    }
    isDirty(): boolean {
        return JSON.stringify(this.getFields().toJson()) !== JSON.stringify(this.previousData.toJson());
    }
}